import { ListPaginationSettings, ListFilterSettings } from './quick-list-data-source.service-base';

export class StaticQuickListDataSourceBase<TItem> {
    private data: TItem[] = [];

    public constructor() {}

    public setData(data: TItem[]): void {
        if (!data) data = [];
        this.data = data;
    }

    public getData(
        pagination: ListPaginationSettings,
        filter: ListFilterSettings
    ): TItem[] {
        if (pagination.pageNumber > 0) return [];
        return this.data;
    }
}
